import { useNovaEventing } from '@nova/react';
import { AppBarEvents } from '@office-start/appbar-events';
import React from 'react';
export var AppBarRenderError = function (props) {
    var novaEventing = useNovaEventing();
    React.useEffect(function () {
        // Fire a Nova event
        var appBarRenderErrorEvent = AppBarEvents.renderError(function () {
            var _a, _b, _c;
            var error = {
                name: "".concat(props.boundarySource, "::").concat((_a = props.error) === null || _a === void 0 ? void 0 : _a.name),
                message: ((_b = props.error) === null || _b === void 0 ? void 0 : _b.message) || 'Unknown error',
                stack: (_c = props.error) === null || _c === void 0 ? void 0 : _c.stack,
            };
            return {
                error: error,
                errorInfo: props.errorInfo,
            };
        });
        novaEventing.generateEvent({
            event: appBarRenderErrorEvent,
        });
    }, [novaEventing, props.boundarySource, props.error, props.errorInfo]);
    return null;
};
//# sourceMappingURL=AppBarRenderError.js.map